import { useEffect, useState } from "react";

import Layout from "../../components/reusable/Layout";
import Title from "../../components/reusable/Title";

import ChartSection from "./ChartSection";
import GNCMacronutrientTips from "./GNCMacronutrientTips";

import classes from "./MacronutrientBalancePage.module.css";
import { SvgConverterType } from "../../reports/Report";

const MacronutrientBalancePage = ({
  data,
  onSvgConverter,
  isEvityReport,
  isGNCReport,
  isFountainLife,
}: {
  data: any;
  onSvgConverter: SvgConverterType;
  isEvityReport?: boolean;
  isGNCReport?: boolean;
  isFountainLife?: boolean;
}) => {
  const [imgLoad, setImgLoad] = useState(false);

  useEffect(() => {
    onSvgConverter("main", "result", 760);
    setImgLoad(true);
  }, [onSvgConverter]);

  if (isFountainLife) {
    return null;
  }

  let imgMain = (
    <div id="main">
      {data.SECTIONS.map((section: any) => (
        <div
          key={section.INDEX}
          id="customRadarChart_section1"
          className={classes.section}
        >
          <ChartSection data={section} />
        </div>
      ))}
      {isGNCReport && <GNCMacronutrientTips />}
    </div>
  );

  return (
    <Layout isEvityReport={isEvityReport}>
      <Title title={data.TITLE} />
      <div id="result" className={classes.imgMain}>
        {!imgLoad && imgMain}
      </div>
    </Layout>
  );
};

export default MacronutrientBalancePage;
